//for prodauction REACT_APP_API_PRO_URL
//for test REACT_APP_API_TEST_URL

import { choiseHttpOrHttps } from "./handleTheHttp(s)ForPhones";

let protcol = choiseHttpOrHttps();

const apiUrl = protcol+process.env.REACT_APP_API_PRO_URL;


export default apiUrl;

